import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));

// New Global API Pages
export const StatsGlobalPage = Loadable(lazy(() => import('../pages/Stats/GlobalPage')));
export const StatsRegionsPage = Loadable(lazy(() => import('../pages/Stats/RegionsPage')));
export const FactoryListPage = Loadable(lazy(() => import('../pages/Factory/ListPage')));
export const FactoryKeysPage = Loadable(lazy(() => import('../pages/Factory/KeysPage')));
export const TenantsListPage = Loadable(lazy(() => import('../pages/Tenants/ListPage')));
export const TenantDetailPage = Loadable(lazy(() => import('../pages/Tenants/DetailPage')));

// Firmware Pages
export const FirmwareReleasesPage = Loadable(lazy(() => import('../pages/Firmware/ReleasesPage')));
export const FirmwareTargetsPage = Loadable(lazy(() => import('../pages/Firmware/TargetsPage')));
export const FirmwareKeysPage = Loadable(lazy(() => import('../pages/Firmware/KeysPage')));
